module.exports = __webpack_public_path__ + "img/Steinig.3d63ffa6.jpg";